export default function authHeader() {
  const user = JSON.parse(localStorage.getItem('user'));

  if (user && user.jwt.token) {
    return { Authorization: `Bearer ${user.jwt.token}` };
  }
  return {};
}
